import React from 'react';
import BigCard from '../../../customBigCard';
import adminCSS from './admin.module.css';
//import AddOrderedProductForm from '../../../VP/addOrderedProduct';

function VpAdminHome() {

    const redirectToNettbutikkOversikt = () => {
        window.location.href="/VP/admin/nettbutikk";
    }

    const redirectToVerkstedsOversikt = () => {
        window.location.href="/VP/admin/verksteder";
    }

    const redirectToKjedeOversikt = () => {
        window.location.href="/VP/admin/kjeder";
    }

    const redirectToOrdreOversikt = () => {
        window.location.href="/VP/admin/ordre";
    }

    return(
        <div>
            <h2>Velkommen til Verktøypartners adminportal</h2>
            <div className={adminCSS.cardContainer}>
                <div className={adminCSS.card}>
                    <BigCard 
                        p1="OVERSIKT OVER PRODUKTER"
                        p2="REDIGER PRODUKTER"
                        p3="LEGG TIL / FJERN PRODUKTER"
                        p_className="big-card-text" 
                        buttonTitle="NETTBUTIKK" 
                        buttonClass="nettbutikk-button text-white my-3 col-10 m-auto py-3" 
                        cardClass={`${CSS.card} col-12`} 
                        buttonOnClick = {redirectToNettbutikkOversikt}
                    />
                </div>
                <div className={adminCSS.card}>
                        <BigCard 
                            p1="OVERSIKT OVER VERKSTEDER"
                            p2="REDIGER VERKSTEDER"
                            p3="LEGG TIL / FJERN VERKSTEDER"
                            p_className="big-card-text" 
                            buttonTitle="VERKSTEDER" 
                            buttonClass="VP-admin-button text-white my-3 col-10 m-auto py-3" 
                            cardClass={`${CSS.card} col-12`} 
                            buttonOnClick = {redirectToVerkstedsOversikt}
                        />
                    </div>
                    <div className={adminCSS.card}>
                        <BigCard 
                            p1="OVERSIKT OVER KJEDER"
                            p2="REDIGER KJEDER"
                            p3="LEGG TIL / FJERN KJEDER"
                            p_className="big-card-text" 
                            buttonTitle="KJEDER" 
                            buttonClass="produkt-button text-white my-3 col-10 m-auto py-3" 
                            cardClass={`${CSS.card} col-12`} 
                            buttonOnClick = {redirectToKjedeOversikt}
                        />
                    </div>
                    <div className={`${adminCSS.card}`}>
                        <BigCard 
                            p1="ORDREOVERSIKT"
                            p2="GODKJENN/AVSLÅ ORDRE"
                            p3="ORDREHISTORIKK"
                            p_className="big-card-text" 
                            buttonTitle="ORDRE" 
                            buttonClass="serviceButton text-white my-3 col-10 m-auto py-3" 
                            cardClass={`${adminCSS.serviceButton} col-12`} 
                            buttonOnClick = {redirectToOrdreOversikt}
                        />
                    </div>
            </div>
        </div>
        
        
    )
}

export default VpAdminHome;